// src/hooks/useEstadoAgenda.js
import { useCallback } from "react";
import { useFechaActual } from "./useFechaActual";

export const useEstadoAgenda = () => {
  const { calcularDiferenciaDias } = useFechaActual();

  const calcularEstado = useCallback(
    (fechaCaducidad) => {
      if (!fechaCaducidad) return { estado: "", bg: "" };

      // calcularDiferenciaDias debe devolver número o null/undefined
      const diff = calcularDiferenciaDias(fechaCaducidad);

      // validar número finito
      if (diff === null || diff === undefined || !Number.isFinite(diff)) {
        return { estado: "", bg: "" };
      }

      const diffDays = Math.floor(diff); // asegurar entero

      if (diffDays < 0) return { estado: "Vencida", bg: "bg-red color-white" };
      if (diffDays === 0)
        return { estado: "Vence hoy", bg: "bg-yellow color-white" };
      if (diffDays === 1)
        return { estado: "Vence mañana", bg: "bg-success color-white" };
      return { estado: `Vence en ${diffDays} días`, bg: "bg-azul color-white" };
    },
    [calcularDiferenciaDias]
  );


// Este me calcula la actividad mas pendiente de mi lista de actividades 
  const obtenerEstadoPrioritario = useCallback(
    (detalles = []) => {
      if (!Array.isArray(detalles) || detalles.length === 0) {
        return { estado: "", bg: "" };
      }

      const prioridades = {
        Vencida: 1,
        "Vence hoy": 2,
        "Vence mañana": 3,
        "Vence en": 4,
      };

      let estadoPrioritario = "";
      let bgPrioritario = "";
      let prioridadMinima = Infinity;
      let menorDiff = Infinity; // 👈 Para elegir la fecha más próxima

      const detallesFiltrados = detalles.filter((d) => d && d.fecha_caducidad);

      detallesFiltrados.forEach((detalle) => {
        const { estado, bg } = calcularEstado(detalle.fecha_caducidad);
        if (!estado) return;

        const tipo = estado.startsWith("Vence en") ? "Vence en" : estado;
        const prioridad = prioridades[tipo] ?? 999;
        const diff = calcularDiferenciaDias(detalle.fecha_caducidad);

        if (
          prioridad < prioridadMinima ||
          (prioridad === prioridadMinima && diff < menorDiff)
        ) {
          prioridadMinima = prioridad;
          menorDiff = diff;
          estadoPrioritario = estado;
          bgPrioritario = bg;
        }
      });

      return { estado: estadoPrioritario, bg: bgPrioritario };
    },
    [calcularEstado, calcularDiferenciaDias]
  );

  return { calcularEstado, obtenerEstadoPrioritario };
};
